import React from "react";
import { Col, Modal, Row } from "reactstrap";
import { FaInfoCircle } from "react-icons/fa";
import { startCase } from 'lodash';
import PropTypes from 'prop-types';

const InfoDialog = ({
    isShow = true,
    headerInfo,
    fields,
    onSave,
    onCancel,
    confirmLoading
}) => {
    return (
        <Modal
            isOpen={isShow}
            size="lg"
            centered
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0">
                    <span style={{ marginRight: '10px' }}>
                        <FaInfoCircle />
                    </span>
                    {headerInfo}
                </h5>
                <button
                    type="button"
                    onClick={onCancel}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
            <Row style={{padding: '0 10px'}}>
        {fields.map((field, index) => (
              <Col key={field.label} md={6}>
              <div style={{ marginBottom: '35px'}}>
                  <div style={{ fontWeight: '600' }}>
                      {startCase(field.label)}{' '}
                  </div>
                  <div style={{ fontSize: '14px', color: '#555' }}>
                      {' '}{field.value}
                  </div>
              </div>
          </Col>
        ))}
    </Row>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    onClick={onCancel}
                    className="btn btn-outline-secondary"
                    data-dismiss="modal"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-success"
                    onClick={onSave}
                    disabled={confirmLoading}
                >
                   {confirmLoading && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {confirmLoading && <span>Proceeding</span>}
                    {!confirmLoading && <span>Confirm</span>}
                </button>
            </div>
        </Modal>
    );
}

InfoDialog.propTypes = {
    isShow: PropTypes.bool,
    headerInfo: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    confirmLoading: PropTypes.bool.isRequired,
};


export default InfoDialog;